import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Erreur lors de la déconnexion:', err);
      navigate('/login');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to={isAuthenticated ? "/tenants" : "/login"} className="navbar-logo">
          <img
            src="/assets/sigamixlogo.png"
            alt="Sigamix Report Server"
            className="navbar-logo-img"
          />
        </Link>
      </div>
      
      <div className="navbar-menu">
        {isAuthenticated ? (
          <>
            <Link to="/tenants" className="navbar-item">
              Tenants
            </Link>
            <Link to="/reports" className="navbar-item">
              Rapports
            </Link>
            {user?.isAdmin && (
              <Link to="/users" className="navbar-item">
                Utilisateurs
              </Link>
            )}
            <div className="user-menu">
              <button 
                className="navbar-item user-btn"
                onClick={() => setShowUserMenu(!showUserMenu)}
              >
                {user?.firstName} {user?.lastName} ▼
              </button>
              {showUserMenu && (
                <div className="user-dropdown">
                  <Link to="/profile" className="dropdown-item">
                    Mon profil
                  </Link>
                  <button onClick={handleLogout} className="dropdown-item logout-btn">
                    Déconnexion
                  </button>
                </div>
              )}
            </div>
          </>
        ) : (
          <Link to="/login" className="navbar-item">
            Connexion
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;

